var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minimal-layout"},[_c('div',{staticClass:"w-100 relative",attrs:{"id":"viewport"}},[_c('minimal-header'),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('main-footer')],2)])}
var staticRenderFns = []

export { render, staticRenderFns }